var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
  // left: `${x}px`, top: `${y}px`,
  width: (_vm.width + "px"), height: (_vm.height + "px"),
}),attrs:{"id":"minimap"}},[_c('canvas',{ref:"canvas",style:({width: (_vm.width + "px"), height: (_vm.height + "px")}),attrs:{"width":2 * _vm.width,"height":2 * _vm.height}}),_c('div',{staticClass:"box",style:({
      left: ((_vm.box.x - _vm.box.width / 2) + "px"), top: ((_vm.box.y - _vm.box.height / 2) + "px"),
      width: ((_vm.box.width) + "px"), height: ((_vm.box.height) + "px"),
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }